export default {
    Notifications_Title: 'Your calendar settings',
    Notifications: 'Notifications',
    Notifications_Summary_1: 'The list below shows events you will receive notifications for.',
    Notifications_Summary_2: 'Notifications will appear before the event releases when you browse FXStreet.',
    Notifications_Search_Event: 'Search event',
    Notifications_Event: 'Event',
    Notifications_NotifyMe: 'Notify me',
    Notifications_Currency: 'Asset',
    Notifications_Apply: 'Apply',
    Pop_Up_Title:'Your filters will be reset. Do you want to change view?',
    Pop_Up_Summary:'If you change view, your previously saved filters will reset to default. Confirm you want to continue.',
    Pop_Up_Cancel_Button: 'Cancel',
    Pop_Up_Confirm_Button: 'Change view'
}
